// @ts-nocheck
import React, { useEffect, useState } from 'react';
import { Box, Stack } from '@mui/material';
import { FieldsInputTitle } from 'pages/Forms/FormResults/FormResultDetails/ResultInputs/components/common/FieldsInputTitle';
import DatePickerWithPopper from 'components/atoms/DatePickerWithPopper/DatePickerWithPopper';
import MuiTimepicker from 'components/__v2__/MuiTimepicker/Timepicker';
import useCustomForm from 'pages/Forms/context/useCustomForm';
import ClearSelection from '../components/ClearSelection';

const DateTimeLocalFormFieldPreview = ({
  element,
  answer,
  handleDirty,
  updateAnswerInPrefilledElements,
  shouldBeReadOnly,
}) => {
  const [, { setAnswer }] = useCustomForm();
  const [selectedDateTime, setSelectedDateTime] = useState(
    answer && isValidDate(new Date(answer)) ? new Date(answer) : null,
  );

  function isValidDate(date) {
    // eslint-disable-next-line no-restricted-globals
    return date instanceof Date && !isNaN(date);
  }

  const handleDateTimeChange = (dateTime) => {
    if (dateTime && !isValidDate(dateTime)) {
      console.warn('Invalid date/time selected:', dateTime);
      return;
    }

    setSelectedDateTime(dateTime);

    if (dateTime && isValidDate(dateTime)) {
      const adjustedDate = new Date(
        dateTime.getTime() - dateTime.getTimezoneOffset() * 60000,
      );
      const formattedDate = adjustedDate.toISOString().split('T')[0];
      const hours = dateTime.getHours().toString().padStart(2, '0');
      const minutes = dateTime.getMinutes().toString().padStart(2, '0');

      const dateTimeString = `${formattedDate}T${hours}:${minutes}`;
      setAnswer(element?.id, dateTimeString);
      if (updateAnswerInPrefilledElements) {
        updateAnswerInPrefilledElements(
          element?.id,
          dateTimeString,
          element?.type,
        );
      }
    } else {
      setSelectedDateTime(null);
      setAnswer(element?.id, '');
      if (updateAnswerInPrefilledElements) {
        updateAnswerInPrefilledElements(element?.id, '', element?.type);
      }
    }
    handleDirty();
  };

  const handleClearSelection = () => {
    setSelectedDateTime(null);
    setAnswer(element?.id, '');
    if (updateAnswerInPrefilledElements) {
      updateAnswerInPrefilledElements(element?.id, '', element?.type);
    }
    handleDirty();
  };

  useEffect(() => {
    if (answer && isValidDate(new Date(answer))) {
      setSelectedDateTime(new Date(answer));
    } else if (answer) {
      console.warn('Invalid answer date provided:', answer);
      setSelectedDateTime(null);
    }
  }, [answer]);

  return (
    <Box key={element?.id} m={1}>
      <FieldsInputTitle
        label={element?.label || element?.name}
        isRequired={element?.isRequired}
      />
      <Stack direction="row" alignItems="center" spacing={1}>
        <Box width={400}>
          <DatePickerWithPopper
            startDate={selectedDateTime}
            dateChangeHandler={handleDateTimeChange}
            disabled={shouldBeReadOnly}
          />
        </Box>
        <Box width={300}>
          <MuiTimepicker
            value={selectedDateTime}
            onChange={handleDateTimeChange}
            placeholder="Choose your time"
            disabled={shouldBeReadOnly}
          />
        </Box>
      </Stack>
      {!element?.isRequired && selectedDateTime && !shouldBeReadOnly && (
        <ClearSelection handleClear={handleClearSelection} />
      )}
    </Box>
  );
};

export default DateTimeLocalFormFieldPreview;
